import { Component } from '@angular/core';

@Component({
	selector: 'app-not-found',
	template: `
		<div class="not-found-container">
			<img src="assets/img/404.png" alt="404" class="error-image" />
		</div>
	`,
	styles: [`
		.not-found-container {
			display: flex;
			justify-content: center;
			align-items: center;
			min-height: 100vh;
			padding: 20px;
		}
		
		.error-image {
			max-width: 100%;
			max-height: 80vh;
			object-fit: contain;
		}
	`]
})
export class NotFoundComponent {
}
